module.exports = "/_next/static/images/new_device-44f91531f77fba5446cbd8d104c31db8.svg";